exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ipoint-success{margin-top:80px}.ipoint-success-content{width:80%;margin:0 auto;background-color:#fff;padding:50px 150px;margin-bottom:200px}.ipoint-success-content p{font-size:24px;color:#5e6d82;letter-spacing:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26da1c06","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profiler/iPointTransfer.vue
// module id = 354
// module chunks = 0